// extracted by mini-css-extract-plugin
export default {"picture_alternate":"Main_picture_alternate__CAw3y"};